export default eventEmitter;

function eventEmitter() {
  return eventEmitter;

  ////////////////////////

  function eventEmitter() {
    let suscribers = {};
    return {
      on: suscribe,
      emit: emit,
      destroy: destroy,
    };

    /////////////////////

    function suscribe(event, callback) {
      if (!suscribers[event]) {
        suscribers[event] = [];
      }
      suscribers[event].push(callback);
      return unsuscribeFactory(callback);

      function unsuscribeFactory(callback) {
        return () => {
          const index = suscribers[event].findIndex(fn => fn === callback);
          if (index === -1) {
            return;
          }
          suscribers[event].splice(index, 1);
        };
      }
    }

    function emit(event, data, callback) {
      suscribers[event] && suscribers[event].map(fn => fn(data));
      // (suscribers[event]) && suscribers[event].map((fn) => fn.apply(null, data));
      callback && callback();
    }

    // function emit(event){
    //   let args = _optimizedSliceCall(arguments, 1);
    //   (suscribers[event]) && suscribers[event].map((fn) => fn.apply(null, args));
    // }
    //
    // function _optimizedSliceCall(_arguments, sliced){
    //   const args = new Array (_arguments.length - sliced);
    //   for (let i=0, len=args.length; i<len; ++i) {
    //     args[i] = _arguments[i + sliced];
    //   }
    //   return args;
    // }

    function destroy() {
      suscribers = {};
    }
  }
} // service
